import { render, staticRenderFns } from "./KanbanCardModal.vue?vue&type=template&id=4310d222&scoped=true&"
import script from "./KanbanCardModal.vue?vue&type=script&lang=js&"
export * from "./KanbanCardModal.vue?vue&type=script&lang=js&"
import style0 from "./KanbanCardModal.vue?vue&type=style&index=0&id=4310d222&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4310d222",
  null
  
)

export default component.exports